import { AppError } from './app-error'

export class ForbiddenError extends AppError {
  private static NAME: string = 'ForbiddenError'
  public static MESSAGE: string = 'A ação que você está tentando realizar não está autorizada!'

  constructor(message?: string | null, title?: string | undefined) {
    super(ForbiddenError.NAME, message ?? ForbiddenError.MESSAGE, title)
  }
}
